// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.4
//   protoc               v5.28.2
// source: google/api/annotations.proto

/* eslint-disable */

export const protobufPackage = "google.api";
